import { z } from 'zod';
export const uuidIdSchema = z.string().uuid();
export const playerIdSchema = uuidIdSchema.brand();
export const teamIdSchema = uuidIdSchema.brand();
export const gameweekIdSchema = uuidIdSchema.brand();
export const seasonIdSchema = uuidIdSchema.brand();
export const duelIdSchema = uuidIdSchema.brand();
